import {fromJS, Map} from 'immutable';
import {Store} from 'client/framework';
import simpleDropdownActions from './SimpleDropdown.actions';

export default class SimpleDropdownStore extends Store {
  constructor(name: string) {
    super(name);
    this.setInitialData(
      fromJS({
        selectedItem: {},
        isOpen: false,
        optionsRect: null
      })
    );
    this.handleTargeted(simpleDropdownActions.RESET_STORE, this.resetStore, undefined);
    this.handleTargeted(simpleDropdownActions.SET_SELECTED_ITEM, this._setSelectedItem, undefined);
    this.handleTargeted(simpleDropdownActions.SET_IS_OPEN, this._setIsOpen, undefined);
    this.handleTargeted(
      simpleDropdownActions.SET_OPTIONS_RECT,
      this.setProperty('optionsRect'),
      undefined
    );
    this.handleTargeted(simpleDropdownActions.TOGGLE_IS_OPEN, this._toggleIsOpen, undefined);
  }

  _setSelectedItem(item: Map<unknown, unknown>) {
    this.writeData('selectedItem', item);
  }

  _setIsOpen(isOpen: boolean) {
    this.writeData('isOpen', isOpen);
  }

  _toggleIsOpen() {
    this.writeData('isOpen', !this.isOpen());
  }

  getSelectedItem(): Map<unknown, unknown> {
    return this.readData('selectedItem') || Map();
  }

  isOpen(): boolean {
    return this.readData('isOpen');
  }

  getOptionsRect = (): Record<string, unknown> | null => this.readData('optionsRect');
}
